.navButton {
  display: flex;
  color: #1890ff;
  align-items: center;
  padding: 0.2rem 1.2rem;
  border-radius: 0.5rem;
  /* margin-bottom: 0.5rem; */
  transition: all 0.3s ease;
}

.sidebarWrapper {
  display: flex;
  gap: 0.5rem;
}

.navButton:hover {
  /* background-color: #edf3fd; */
  background-color: hsla(240, 9%, 59%, 0.1);
}

.selectedbtn {
  /* background-color: #edf3fd; */
  background-color: hsla(240, 9%, 59%, 0.1);
}

.navText {
  padding-left: 0.3rem;
}

@media only screen and (max-width: 550px) {
  .layout {
    grid-template-columns: 1fr;
    grid-template-rows: 0.2fr auto 0.8fr;
    grid-template-areas:
      'nav'
      'main'
      'sidebarSmall';
  }
  .navText {
    padding: 0.3rem 0.3rem 0 0;
  }

  .selectedbtn {
    background-color: transparent;
  }

  .navButton {
    padding: 0.5rem 1rem;
    justify-content: center;
    flex-direction: column;
  }

  .sidebarWrapper {
    display: flex;
    justify-content: space-evenly;
    width: 100%;
  }
}
